import React from 'react';
import Select, {Creatable} from 'react-select';
import Toaster from 'toastr';
import { connect } from 'react-redux';
import { Permissioned } from 'react-permissions';
import Messages from '../../../configurations/messages';
import Permissions from '../../../configurations/permissions';
import Util from '../../../util/util';
import ArbiterApi from '../../../api/ArbiterApi';
import TransactionsApi from '../../../api/TransactionsApi';
import Modal from '../../common/modal';
import FloatInput from '../../common/floatInput';
import CButton from '../../common/connectedButton';

class TransactionGroupsModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isNew: props.isNew,
            isView: !props.isNew,
            transactionGroup: props.isNew ? {} : props.transactionGroup,
            additionalParameters : [],
            title: props.isNew ? "New Transaction Group" : `${props.transactionGroup.name}`,
            updating: false,
            touchedForm: false,
            stores: [],
            selectedStore : null,
            nameValidity: -1,
            channelValidity: -1,
            customerReferenceValidity : -1,
            storeValidity : -1

        };
        this.modalStyle = {
            ovelay: {},
            content: {
                top: "80px",
                left: "250px",
                right: "250px",
                bottom: "100px",
                zIndex: "1000"
            }
        }
        this.onTextInputChange = this.onTextInputChange.bind(this);
        this.onStoreChange = this.onStoreChange.bind(this);
        this.onAdditionalParametersChange = this.onAdditionalParametersChange.bind(this);
       
    }

    componentDidMount(){

        //Fetch Stores
        TransactionsApi.getTransactionStores()
            .then(response => {
                let selectedStore = null;
                let stores = response.data.map(val => {

                    let obj  = {};
                    obj.label = val;
                    obj.value = val;
                    if (this.state.transactionGroup.store === val) {
                        selectedStore = obj;
                    }
                    return obj;

                });

                this.setState({ stores, selectedStore });
            })
            .catch(error => {
                Toaster.error(`${error.status} - ${Messages.ERROR_TRANSACTION_STORES} - ${error.data ? error.data.description : error.statusText}`);
                console.log(error);
            })



        if(!this.state.isNew &&  this.state.transactionGroup.additionalParameters){
           this.setState({additionalParameters :  this.state.transactionGroup.additionalParameters.map(val => ({ label : val, value : val}))})
        }


    }

    onTextInputChange(evt) {

        let id = evt.target.id;
        let transactionGroup = Object.assign({}, this.state.transactionGroup);
        transactionGroup[id] = evt.target.value || null;

        let stateUpdate = {
            transactionGroup,
            touchedForm: true
        }
        stateUpdate[id + "Validity"] =  evt && evt.target.value ? 1 : 0;

        this.setState(stateUpdate);
    }
    onAdditionalParametersChange(evt) {
        console.log(evt)
        let transactionGroup = Object.assign({}, this.state.transactionGroup);
        //Remove any parameter that contains space then flatten
        let filteredOptions = evt ? evt.filter(val => {return (val.value.trim().indexOf(" ") === -1)}) : []
        transactionGroup.additionalParameters = filteredOptions.map(obj => (obj.value.trim()));

        this.setState({
            transactionGroup,
            additionalParameters:  filteredOptions,
            touchedForm: true
        });
    }
       
    handleAction(evt) {
        this.setState({ updating: true });

        const transactionGroup = this.state.transactionGroup;
        const isNew = this.state.isNew;
        let promise = this.state.isNew ? ArbiterApi.createTransactionGroup(transactionGroup) : ArbiterApi.updateTransactionGroup(transactionGroup.id, transactionGroup)
        promise.then((response) => {
            Toaster.success(`Transaction Group  '${this.state.transactionGroup.name}' - successfully  ${isNew ? 'created' : 'updated'}`);
            this.setState({ updating: false });
            this.props.onRequestClose(evt, true);
        })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${error.data ? error.data.description : error.statusText}`, `${Messages.ERROR_TRANSACTION_GROUP_UPDATE} - ${error.status}`);
                this.setState({ updating: false });
            })
    }

    onStoreChange(evt) {
        let transactionGroup = Object.assign({}, this.state.transactionGroup);
        transactionGroup.store = evt ? evt.value : null;

        this.setState({
            transactionGroup,
            selectedStore: evt,
            touchedForm: true,
            storeValidity: evt ? 1 : 0
        });
    }


    render() {
        const isNew = this.state.isNew;
        const isView = this.state.isView;
        return (
            <Modal title={this.state.title} isOpen={this.props.isOpen} style={this.modalStyle} onRequestClose={this.props.onRequestClose}>
                {isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label>Name :</label>
                                        <label>{this.state.transactionGroup.name}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Channel :</label>
                                        <label>{this.state.transactionGroup.channel}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Store :</label>
                                        <label>{this.state.transactionGroup.store}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Customer Reference Field :</label>
                                        <label>{this.state.transactionGroup.customerReference}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Additional Parameters :</label>
                                        <label>{this.state.transactionGroup.additionalParameters ? this.state.transactionGroup.additionalParameters.join(",") : ""}</label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isView && 
                <div className="mod-content">
                    <form>
                        <div className="row">
                            <div className="col-md-11">
                                <div className="form-div">
                                    <label>Name :</label>
                                    <FloatInput
                                        id="name"
                                        value={this.state.transactionGroup.name}
                                        onChange={this.onTextInputChange}
                                        placeholder="Enter Name"
                                        showError={this.state.nameValidity === 0} errorMessage={`${Messages.INVALID_NAME}`}
                                    />
                                </div>

                                <div className="form-div">
                                    <label>Channel :</label>
                                    <FloatInput
                                        id="channel"
                                        value={this.state.transactionGroup.channel}
                                        onChange={this.onTextInputChange}
                                        placeholder="Enter Channel"
                                        showError={this.state.channelValidity === 0} errorMessage={`${Messages.INVALID_CHANNEL}`}
                                    />
                                </div>

                                <div className="form-div">
                                    <label>Store :</label>        
                                     <Select
                                            id="store"
                                            value={this.state.selectedStore}
                                            options={this.state.stores}
                                            onChange={this.onStoreChange}
                                            placeholder="Select Store"
                                        />
                                </div>
                                <div className="form-div">
                                    <label>Customer Reference Parameter :</label>
                                    <FloatInput
                                        id="customerReference"
                                        value={this.state.transactionGroup.customerReference}
                                        onChange={this.onTextInputChange}
                                        placeholder="Enter Customer Reference Paramater"
                                        showError={this.state.customerReferenceValidity === 0} errorMessage={`${Messages.INVALID_CUSTOMER_REFERENCE_FIELD}`}
                                    />
                                </div>

                                <div className="form-div">
                                    <label>Additional Parameters :</label>
                                    <Creatable
                                        id="additionalParameters"
                                        placeholder="Comma seperated"
                                        onChange={this.onAdditionalParametersChange}
                                        multi={true} 
                                        options={[]} 
                                        value={this.state.additionalParameters}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                }
                <div className="mod-footer">
                    <div className="mod-footer-buttons">
                        {isView &&
                            <CButton 
                                onClick={(evt) => { this.setState({isView : false}) }} 
                                className="btn btn-primary"
                                allowedPermissions={[Permissions.UPDATE_TRANSACTION_GROUP]}>EDIT</CButton>
                        }
                        {!isView && isNew &&
                            <CButton 
                                onClick={(evt) => { this.handleAction(evt); }} 
                                disabled={this.state.updating || !this.formValid()} 
                                className="btn btn-primary"
                                allowedPermissions={[Permissions.CREATE_TRANSACTION_GROUP]}>CREATE</CButton>

                        }
                        {!isView && !isNew &&
                            <CButton 
                                onClick={(evt) => { this.handleAction(evt); }} 
                                disabled={this.state.updating || !this.formValid()} 
                                className="btn btn-primary"  
                                allowedPermissions={[Permissions.UPDATE_TRANSACTION_GROUP]}>UPDATE</CButton>

                        }
                        <button onClick={(evt) => { this.props.onRequestClose(evt); }} disabled={this.state.updating} className="btn btn-danger">CLOSE</button>
                    </div>
                </div>
            </Modal>
        )
    }

    formValid() {
        if (this.state.isNew)
            //Each field must have an exact validity i.e. validity must exact equal '1'
            return this.state.touchedForm && this.state.nameValidity === 1 && this.state.channelValidity === 1 && this.state.storeValidity === 1 && this.state.customerReferenceValidity === 1;
        //all fields must be valid i.e validity must be 1 or -1 (for untouched fields)
        return this.state.touchedForm && this.state.nameValidity && this.state.channelValidity && this.state.storeValidity && this.state.customerReferenceValidity;
    }

}

export default connect(Util.defaultMapStateToProps)(Permissioned(TransactionGroupsModal, [Permissions.VIEW_DISPUTE_REGION]));


// WEBPACK FOOTER //
// ./src/components/admin/transactionGroups/transactionGroupsModal.js